module.exports = __webpack_public_path__ + "img/pc-en.09ae0031.png";